import React from 'react'

import { useActions, useValues } from 'kea'

import I18n from 'lib/i18n'
import Textarea from 'lib/forms/textarea-autosize'

import sceneLogic from '~/scenes/pages/request/logic'

const PersonalNote = () => {
  const { setPersonalNote } = useActions(sceneLogic)
  const { personalNote, errors } = useValues(sceneLogic)

  return (
    <div className={`form-element full-width${errors.personalNote ? ' has-errors' : ''}`}>
      <label htmlFor='personal-note-input' className='block'>
        {I18n.t('react.request.request.personal_note')}
      </label>
      <Textarea
        id='personal-note-input'
        value={personalNote}
        placeholder={I18n.t('react.request.request.personal_note_placeholder')}
        rows={4}
        onChange={event => setPersonalNote(event.target.value)}
      />
      {errors.personalNote && <div className='simple-error'>{errors.personalNote}</div>}
    </div>
  )
}

export default PersonalNote
